import React, { useState, useEffect } from "react";
import "./Inspector.css";
import Style from "./Style";
import Setting from "./Setting";
import Interaction from "./Interaction";

function Inspector({
  selectedElement,
  setSelectedElement,
  updateElementStyles,
  updateElementText,
  updateElementClassName,
  assets,
  setShowAssetsSidebar,
  selectedAssetFile,
  handleAssetSelect,
  elements,
  setElements,
  globalClassNames,
  addToGlobalClassNames,
  updateElementInteractions,
  selectedDevice,
  onDeviceSelect,
  classStylesRegistry,
  setClassStylesRegistry,
  appliedStylesRegistry,
  setAppliedStylesRegistry,
  pages,
  currentPageId,
  selectedContentItem,
  cmsContentTypes,
  cmsContent,
  updateElementState,
  setPages,
  getDefaultStyles,
  combinedClassStylesRegistry,
  setCombinedClassStylesRegistry,
  showRichTextEditorForNewElement,
  siteFonts
}) {
  const [view, setView] = useState("style");

  // Add event listener for showing settings from the popup
  useEffect(() => {
    const handleShowSettings = (event) => {
      // Switch to settings view
      setView("setting");
      
      // Make sure the element is selected (in case it was triggered from elsewhere)
      if (event.detail?.elementId) {
        const elementToSelect = elements.find(el => el.id === event.detail.elementId);
        if (elementToSelect) {
          setSelectedElement(elementToSelect);
        }
      }
    };

    // Listen for the custom event
    document.addEventListener('showElementInspectorSettings', handleShowSettings);
    
    // Clean up
    return () => {
      document.removeEventListener('showElementInspectorSettings', handleShowSettings);
    };
  }, [elements, setSelectedElement]);

  // Auto-switch to settings view for new rich-text elements
  useEffect(() => {
    if (showRichTextEditorForNewElement && selectedElement?.type === 'rich-text') {
      setView("setting");
    }
  }, [showRichTextEditorForNewElement, selectedElement]);

  if (!selectedElement) {
    return (
      <div className="right-section">
        <p className="no-selection">Select an element to edit its properties</p>
      </div>
    );
  }

  return (
    <div className="right-section">
      <div className="properties-container">
        <div className="view-toggle-buttons">
          <button
            onClick={() => setView("style")}
            className={view === "style" ? "active" : ""}
          >
            Style
          </button>
          <button
            onClick={() => setView("setting")}
            className={view === "setting" ? "active" : ""}
          >
            Setting
          </button>
          <button
            onClick={() => setView("interaction")}
            className={view === "interaction" ? "active" : ""}
          >
            Interaction
          </button>
        </div>
        {view === "style" ? (
          <Style
            selectedElement={selectedElement}
            updateElementStyles={updateElementStyles}
            updateElementText={updateElementText}
            updateElementClassName={updateElementClassName}
            elements={elements}
            setElements={setElements}
            globalClassNames={globalClassNames}
            addToGlobalClassNames={addToGlobalClassNames}
            setSelectedElement={setSelectedElement}
            selectedDevice={selectedDevice}
            onDeviceSelect={onDeviceSelect}
            classStylesRegistry={classStylesRegistry}
            setClassStylesRegistry={setClassStylesRegistry}
            appliedStylesRegistry={appliedStylesRegistry}
            setAppliedStylesRegistry={setAppliedStylesRegistry}
            updateElementState={updateElementState}
            setPages={setPages}
            currentPageId={currentPageId}
            getDefaultStyles={getDefaultStyles}
            combinedClassStylesRegistry={combinedClassStylesRegistry}
            setCombinedClassStylesRegistry={setCombinedClassStylesRegistry}
            assets={assets}
            siteFonts={siteFonts}
          />
        ) : view === "setting" ? (
          <Setting
            selectedElement={selectedElement}
            updateElementText={updateElementText}
            updateElementClassName={updateElementClassName}
            setSelectedElement={setSelectedElement}
            assets={assets}
            setShowAssetsSidebar={setShowAssetsSidebar}
            selectedAssetFile={selectedAssetFile}
            onSelectAsset={handleAssetSelect}
            pages={pages}
            setPages={setPages}
            elements={elements}
            setElements={setElements}
            currentPageId={currentPageId}
            selectedContentItem={selectedContentItem}
            cmsContentTypes={cmsContentTypes}
            cmsContent={cmsContent}
            classStylesRegistry={classStylesRegistry}
            setClassStylesRegistry={setClassStylesRegistry}
            selectedDevice={selectedDevice}
            showRichTextEditorForNewElement={showRichTextEditorForNewElement}
          />
        ) : (
          <Interaction
            selectedElement={selectedElement}
            elements={elements}
            updateElementInteractions={updateElementInteractions}
          />
        )}
      </div>
    </div>
  );
}

export default Inspector;
